export default __webpack_public_path__ + "static/media/fit-to-width.76341a9e.svg";